/*
 * @Author: raoyiyu 'raoyiyu@cdqcp.com'
 * @Date: 2022-08-08 11:22:45
 * @LastEditors: raoyiyu 'raoyiyu@cdqcp.com'
 * @LastEditTime: 2022-08-08 14:08:06
 * @FilePath: \reportservere:\webcode\project\git-code\module-h5\src\bycx\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import App from './App';
import router from './router';
// import store from './store';
Vue.config.productionTip = false;

// 全局前置守卫
router.beforeEach((to, from, next) => {
    // 动态修改页面标题
    if (to.meta.title) {
        document.title = to.meta.title;
    };
    next();
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    // store,
    router,
    components: { App },
    template: '<App/>',

})



// WEBPACK FOOTER //
// ./src/bycx/main.js